module.exports = __webpack_public_path__ + "img/gg.357e1e33.svg";